import { ObligationType as Obligation_Type_Enum } from '@risksmart-app/domain/src/types/consts/obligation-type';
import {
  defaultSchedule,
  ScheduleSchema,
} from 'src/pages/controls/update/forms/scheduleSchema';
import {
  CustomAttributeDataSchema,
  InheritedContributorSchema,
  NullableStringDateSchema,
  TagsAndDepartmentsSchema,
  UserOrGroupsSchema,
} from 'src/schemas/global';
import { z } from 'zod';

const message = 'Required';

const checkForRequiredParentId = (
  {
    type,
    parentId,
  }: { type: Obligation_Type_Enum; parentId: null | string | undefined },
  ctx: z.RefinementCtx
) => {
  if (type !== Obligation_Type_Enum.Standard && !parentId) {
    ctx.addIssue({
      message,
      code: z.ZodIssueCode.custom,
      path: ['ParentId'],
    });
  }
};

const defaultSchema = z
  .object({
    Title: z.string().min(1, { message }),
    Description: z.string(),
    Type: z.nativeEnum(Obligation_Type_Enum),
    ParentId: z.string().uuid().nullish(),
    Adherence: z.string().nullish(),
    Interpretation: z.string().nullish(),
    Contributors: UserOrGroupsSchema,
    Viewers: UserOrGroupsSchema,
    Owners: UserOrGroupsSchema.min(1, { message }),
    NextTestDate: NullableStringDateSchema,
    TagTypeIds: z.array(z.string()),
    DepartmentTypeIds: z.array(z.string()),
    ancestorContributors: InheritedContributorSchema,
  })
  .and(ScheduleSchema)
  .and(CustomAttributeDataSchema);

export const ObligationSchema = defaultSchema
  .superRefine((values, ctx) => {
    checkForRequiredParentId(
      { type: values.Type, parentId: values.ParentId },
      ctx
    );
  })
  .and(TagsAndDepartmentsSchema);

export type ObligationFormFieldData = z.infer<typeof ObligationSchema>;

export const defaultValues: ObligationFormFieldData = {
  Title: '',
  Description: '',
  Type: Obligation_Type_Enum.Standard,
  ParentId: null,
  Adherence: '',
  Interpretation: '',
  Owners: [],
  TagTypeIds: [],
  DepartmentTypeIds: [],
  CustomAttributeData: null,
  Contributors: [],
  Viewers: [],
  ancestorContributors: [],
  tags: [],
  departments: [],
  schedule: defaultSchedule,
};
